import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import Layout from "../../components/sutea/Layout"
import TopContact from "../../components/sutea/TopContact"
import TopFeature from "../../components/sutea/TopFeature"
import TopInstagram from "../../components/sutea/TopInstagram"
import TopPartners from "../../components/sutea/TopPartners"
import TopSlider from "../../components/sutea/TopSlider"
import SEO from "../../components/Seo"
import About from "../../components/sutea/TopAbout"
import Concept from "../../components/shared/top/Concept"
import OpeningShutter from "../../components/shared/top/OpeningShutter"

const query = graphql`
  query {
    logo: file(relativePath: { eq: "sutea/logo.png" }) {
      childImageSharp {
        gatsbyImageData(width: 100)
      }
    }
  }
`

const index = () => {
  const data = useStaticQuery(query)
  return (
    <Layout>
      <SEO siteTitle="すてあ" />
      <OpeningShutter logo={getImage(data.logo)} target="sutea" />
      <TopSlider />
      <Concept name="すてあ" bgDotes="md:bg-suteaFourDots" />
      <About target="sutea" />
      <TopFeature />
      <TopInstagram />
      <TopPartners />
      <TopContact />
    </Layout>
  )
}

export default index
